import type { Message_ } from 'src/api/db/apiMessage'

type CostMessage = Pick<Message_, 'role' | 'content'> & {
  created_at?: string | null
  id?: number | null
}

const parseMessageContent = (content: string | null): Record<string, unknown> => {
  if (!content) return {}
  try {
    const parsed = JSON.parse(content)
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>
    }
  } catch {
    // Non-JSON content has no cost fields.
  }
  return {}
}

/** Latest persisted running total, else the sum of per-turn `cost_usd`. */
export const getChatCostUsd = (
  messages: CostMessage[] | null | undefined
): number | null => {
  if (!messages?.length) return null

  const sorted = [...messages].sort((a, b) => {
    const t =
      new Date(a.created_at ?? 0).getTime() -
      new Date(b.created_at ?? 0).getTime()
    if (t !== 0) return t
    return (a.id ?? 0) - (b.id ?? 0)
  })

  for (let i = sorted.length - 1; i >= 0; i--) {
    const parsed = parseMessageContent(sorted[i].content)
    if (typeof parsed.chat_cost_usd === 'number') return parsed.chat_cost_usd
  }

  let sum = 0
  let found = false
  for (const message of sorted) {
    const parsed = parseMessageContent(message.content)
    if (typeof parsed.cost_usd === 'number') {
      sum += parsed.cost_usd
      found = true
    }
  }
  return found ? sum : null
}

export const formatChatCostUsd = (usd: number): string =>
  usd.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  })
